import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { VignetteModel } from '@app/src/views/StepTwo/channelPublication/models/vignette';

export const vignetteService = {
  async get( categoryId: number, publicationId?: number ): Promise<VignetteModel[]> {
    try {
        const { data } = await axiosAjax.get(
          process.env.API_VIGNETTE
            .replace(':categoryId', '' + categoryId)
            .replace(':publicationId', '' + publicationId)
        );
        if (data.error) {
          throw new Error();
        }
        return hydrateData(data.data);
      } catch (e) {
        throw new Error(e);
      }
  }
}
